import SubNavigation from './SubNavigation'

export default SubNavigation
